import React from 'react'
import { Link } from 'react-router-dom'
import LargestCollectionsItem from './LargestCollectionsItem'

function LargestCollections( { title, subtitle, viewPage }) {
    return (
        <div className="singleMarketMove">
            <div className="itemHeading">
                <h3 className="left"> { title } </h3>
                <p><small className="right"> { subtitle } </small></p>
            </div>
            <LargestCollectionsItem
                userPath = "/user/username"
                userProfileThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                userName = "@username"
                COLLECTED = {502}
            />
            <LargestCollectionsItem
                userPath = "/user/username"
                userProfileThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                userName = "@username"
                COLLECTED = {453}
            />
            <LargestCollectionsItem
                userPath = "/user/username"
                userProfileThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                userName = "@username"
                COLLECTED = {342}
            />
            <Link to={viewPage} className="itemFootOpt">See All</Link>
        </div>
    )
}

export default LargestCollections
